export const AUDIT_TYPES = {
    OPEN_PATIENT_CARD: {
        action: 'OPEN_PATIENT_CARD',
        description: 'Open Patient Card',
    },
    OPEN_PATIENT_CONTEXT: {
        action: 'OPEN_PATIENT_CONTEXT',
        description: 'Open Patient Review Context',
    },
    OPEN_HISTORICAL_ACTIVITY: {
        action: 'OPEN_HISTORICAL_ACTIVITY',
        description: 'Open Patient Historical Activity',
    },
    OPEN_FORM: {
        action: 'OPEN_PATIENT_FORM',
        description: 'Open Form',
    },
    OPEN_AGYLE_FORM: {
        action: 'OPEN_AGYLE_FORM',
        description: 'Open Agyle Form',
    },
    OPEN_TRIAGE: {
        action: 'OPEN_PATIENT_TRIAGE',
        description: 'Open Triage Form',
    },
    OPEN_SNT: {
        action: 'OPEN_PATIENT_SNT',
        description: 'Open See and Treat Form',
    },
    OPEN_CLERKING_ED: {
        action: 'OPEN_PATIENT_CLERKING_ED',
        description: 'Open Clerking ED Form',
    },
    OPEN_EMED3: {
        action: 'OPEN_PATIENT_EMED3',
        description: 'Open eMed3 Form',
    },
    PRESCRIPTION_REPRINT: {
        action: 'PRESCRIPTION_REPRINT',
        description: 'Reprint prescription',
    },
    PRESCRIPTION_CREATE: {
        action: 'PRESCRIPTION_CREATE',
        description: 'Create and print prescription',
    },
    EDIT_PATIENT_DEMOGRAPHIC: {
        action: 'EDIT_PATIENT_DEMOGRAPHIC',
        description: 'Edit Patient Demographic',
    },
    EDIT_FULL_PATIENT_DATA: {
        action: 'EDIT_FULL_PATIENT_DATA',
        description: 'Edit Patient Demographic and Activity',
    },
    EDIT_PATIENT_ACTIVITY: {
        action: 'EDIT_PATIENT_ACTIVITY',
        description: 'Edit Patient Activity',
    },
    ADMIT_PATIENT: {
        action: 'ADMIT_PATIENT',
        description: 'Admit Patient',
    },
    MERGE_PATIENT: {
        action: 'MERGE_PATIENT',
        description: 'Merge Patient',
    },
    OPEN_UCR: {
        action: 'OPEN_UCR',
        description: 'Open UCR Context',
    },
    OPEN_DNACPR: {
        action: 'OPEN_DNACPR',
        description: 'Open Do Not Attempt Cardiopulmonary Resuscitation Context',
    },
    OPEN_ICE: {
        action: 'OPEN_INVESTIGATION',
        description: 'Open Investigation Context',
    },
    OPEN_CONTEXT_LINK: {
        action: 'OPEN_CONTEXT_LINK',
        description: 'Open Context Link',
    },
    OPEN_DOCUMENT: {
        action: 'OPEN_DOCUMENT',
        description: 'Open Patient Document',
    },
    SCHEDULER_CREATE_SESSION: {
        action: 'SCHEDULER_CREATE_SESSION',
        description: 'Create a new/edit Session in Scheduler',
    },
    SCHEDULER_CHANGE_STATUS: {
        action: 'SCHEDULER_CHANGE_STATUS',
        description: 'Change Status of a patient in Scheduler',
    },
    SCHEDULER_ASSIGN_SLOT: {
        action: 'SCHEDULER_ASSIGN_SLOT',
        description: 'Create a new/edit Slot in Scheduler',
    },
    SCHEDULER_RESCHEDULE_SLOT: {
        action: 'SCHEDULER_RESCHEDULE_SLOT',
        description: 'Move patient to new appointment slot in Scheduler',
    },
    DEFAULT_ADMITTING_CONSULTANT: {
        action: 'DEFAULT_ADMITTING_CONSULTANT',
        description: 'Change Default Admitting Consultant',
    },
    CLEANING_REQUEST: {
        action: 'CLEANING_REQUEST',
        description: 'Change cleaning request',
    },
    ESCALATION_LEVEL: {
        action: 'ESCALATION_LEVEL',
        description: 'Change escalation level',
    },
    DISCHARGE_PATIENT: {
        action: 'DISCHARGE_PATIENT',
        description: 'Discharge Patient',
    },
    CANCEL_DISCHARGE_PATIENT: {
        action: 'CANCEL_DISCHARGE_PATIENT',
        description: 'Cancel Discharge Patient',
    },
    CANCEL_ATTENDANCE: {
        action: 'CANCEL_ATTENDANCE',
        description: 'Cancel Attendance',
    },
};
